import React from "react";
/**
 * Original Azimut glyphs: 24-unit grid, 1.75-unit strokes, two-unit optical
 * margin. Decorative by default; meaningful standalone use needs aria-label.
 * These are hand-authored components, not generated v2-stroke/Figma exports.
 */
function Glyph({
  children,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": props["aria-label"] ? undefined : true,
    role: props["aria-label"] ? "img" : undefined,
    focusable: "false",
    ...props
  }, children);
}

/** A partitioned atlas, replacing the legacy planet/server/space silhouette. */
export function AzimutRegion(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3h10l7 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3v8H3m8 0v10m0-10h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 6 3 3"
  }));
}

/** Region silhouette stays recognizable when access is restricted. */
export function AzimutRestrictedRegion(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10l7 7v1M11 3v8H3m8 0v10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "15",
    width: "8",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-2a2 2 0 0 1 4 0v2m-2 3v1"
  }));
}

/** Two linked working surfaces, replacing the Pod cube metaphor. */
export function AzimutCollaboration(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4M14 10h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8h5m2 8h5m-10-3 8-2m-8 2 2-3m-2 3 3 2"
  }));
}
export function AzimutAgent(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4 7 4v8l-7 4-7-4V8l7-4Zm0-2v2m0 16v2M2 9l3 1m14 4 3 1M2 15l3-1m14-4 3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11v2m6-2v2m-5 3h4"
  }));
}

/** Collaboration remains recognizable while explicitly conveying restricted access. */
export function AzimutRestrictedCollaboration(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4M6 8h5m-3 5 6-2M8 13l2-3m-2 3 3 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "15",
    width: "8",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-2a2 2 0 0 1 4 0v2m-2 3v1"
  }));
}
export function AzimutConversation(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 3V6a2 2 0 0 1 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9h10M7 13h6"
  }));
}
export function AzimutData(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "7",
    rx: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2M3 19v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1M7 6.5h.01M11 6.5h6"
  }));
}
export function AzimutConnections(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 4h6v6H3zM15 14h6v6h-6zM6 10v7h9m3-3V7H9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2v2m-4 3h1m18 10h1m-4 3v2"
  }));
}
export function AzimutTools(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 3 3 3-5 5-3-3 5-5ZM8 10l6 6m-3 0-5 5-3-3 5-5m6 3 4 4a2 2 0 0 0 3-3l-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 3 3 1 1 3-3-1-1-3Z"
  }));
}
export function AzimutSearch(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "10.5",
    r: "6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5 15.5 5 5"
  }));
}
export function AzimutSettings(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h3m5 0h10M3 12h10m5 0h3M3 18h3m5 0h10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "6",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "12",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "18",
    r: "2.5"
  }));
}
export function AzimutCompass(props) {
  return /*#__PURE__*/React.createElement(Glyph, {
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2v3m0 14v3M2 12h3m14 0h3M7 17l3-7 7-3-3 7-7 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6V4h2m10 0h3v3m0 10v3h-3M7 20H4v-3"
  }));
}
//# sourceMappingURL=AzimutIcons.js.map